/** Reporting / earnings store names (not DDEX delivery store identifiers). */
export const EARNINGS_STORE_NAMES = [
  "AWA",
  "Amazon",
  "Amazon ADS",
  "Amazon Music",
  "Amazon Prime",
  "Amazon Unlimited",
  "Anghami",
  "Apple",
  "Apple Music",
  "Audiomack",
  "BOOM APP",
  "Beatport",
  "Boomplay",
  "Bugs!",
  "Congstar Germany",
  "Deezer",
  "Douyin",
  "FLO Music",
  "Facebook",
  "Genie Music",
  "Instagram",
  "JioSaavn",
  "Joox",
  "Junodownload",
  "KKBOXHK",
  "KKBOXJP",
  "KKBOXTW",
  "Kakao / MelOn",
  "Kugou",
  "Kuwo",
  "LINE Music",
  "Meta",
  "MonkingMe",
  "Napster",
  "ODNOKLASSNIKI",
  "Pandora",
  "PlayPLnew",
  "Plex",
  "QQ music",
  "QQMusic",
  "Qobuz",
  "Snap",
  "SoundCloud",
  "Soundtrack Your Brand",
  "Spotify",
  "Sprint US",
  "TDC Play",
  "TIDAL",
  "TIM Italia",
  "TMobilePL",
  "Telenor DK",
  "Telmore Affiliate",
  "Tidal",
  "TikTok",
  "TikTok Inc.",
  "Tilda",
  "Traxsource",
  "Twitch",
  "UMA",
  "Ultimate Music China",
  "VKONTAKTE",
  "Virgin",
  "Vodafone",
  "WOM Chile",
  "YouSee (TDC)",
  "YouTube",
  "iHeart Radio US",
  "iMusica",
  "iTunes",
  "iTunes Match",
];

/** Relative share when a store appears in simulated earnings (higher = more likely / larger slice). */
export const EARNINGS_STORE_WEIGHTS = {
  Spotify: 30,
  YouTube: 15,
  "Apple Music": 12,
  "Amazon Music": 9,
  SoundCloud: 5,
  Deezer: 4,
  Beatport: 4,
  Facebook: 4,
  Instagram: 4,
  TikTok: 2,
  Pandora: 2,
  Traxsource: 1,
  iTunes: 1,
  Amazon: 3,
  "Amazon Prime": 2,
  "Amazon Unlimited": 2,
  TIDAL: 2,
  Tidal: 1.5,
  Napster: 1.5,
  Meta: 1.5,
  Boomplay: 1,
  Audiomack: 1,
  Qobuz: 1,
  Apple: 1,
  "iTunes Match": 0.8,
  Twitch: 0.8,
  "TikTok Inc.": 0.8,
  Anghami: 0.6,
  Joox: 0.6,
  "JioSaavn": 0.6,
  "LINE Music": 0.6,
  AWA: 0.5,
  "KKBOXJP": 0.5,
  "KKBOXTW": 0.5,
  "KKBOXHK": 0.5,
};

export const earningsFilterStores = EARNINGS_STORE_NAMES.map(name => ({
  id: name,
  name,
}));
